///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export enum GtthImportNodeTypeEnum {
    NEW = 1,
    STANDALONE = 2,
    CONNECTED = 4,
    NOT_CHANGED = 8,
    FROZEN_CHANGED = 16
}
